import React from 'react';
import { Box } from '@chakra-ui/react';
import { PORTRAIT_RATIO } from '@/modules/content/common/videoOrientation';
import { PORTRAIT_FRAME_SIZING } from '@/modules/content/loop/model/loopLayout';

// Tall media frame. Height-driven: the width derives from the ratio via `aspect-ratio`,
// so a 9:16 clip and a 3:4 clip both fill the same height without either being cropped or
// letterboxed.
const PortraitFrame = ({ children, ratio = PORTRAIT_RATIO }: { children: React.ReactNode; ratio?: number }) => (
  <Box
    {...PORTRAIT_FRAME_SIZING}
    borderRadius="16px"
    overflow="hidden"
    backgroundColor="background.cloudGray"
    sx={{ aspectRatio: String(ratio) }}
  >
    {children}
  </Box>
);

export default PortraitFrame;
